<template>
  <div class="bottom-modal px-5 py-4 d-flex flex-column">
    <div class="header d-flex w-100 mb-3 ">
      <h3 class="mb-0">{{title}}</h3>
      <div class="ml-auto">
        <a @click="$emit('close')" title="Close" href="javascript:void(0)">
          <font-awesome-icon :icon="['far', 'times']" />
        </a>
      </div>

    </div>
    <div class="body ">
      <slot>
        What's the latest?
      </slot>
    </div>
    <div class="footer d-flex justify-content-center align-items-center">
      <slot name="footer">
        <div class="mr-1 flex-grow-1">
          <a class="btn btn-outline-info btn-block btn-lg">Patient not interested</a>
        </div>
        <div class="mr-1 flex-grow-1">
          <a class="btn btn-info btn-block btn-lg">Patient not reachable</a>
        </div>
        <div class="ml-1 flex-grow-1">
          <a class="btn btn-primary btn-block btn-lg">Patient scheduled</a>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { default: 'Referral feedback' },
  },
  methods: {
    close() {},
  },
}
</script>

<style lang="scss" scoped>
.bottom-modal {
  height: auto !important;
  position: fixed;
  left: 25px;
  bottom: 25px;
  background: var(--secondary-color);
  color: var(--light-color);
  z-index: 8889;
  border-radius: 8px;
  width: 460px;
  min-height: 260px;

  transform: rotate(0deg);

  h3 {
    color: var(--light-color);
    flex: 1;
  }

  .body {
    font-size: 1.175rem;
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .footer {
    margin-top: auto;
  }
}
</style>